module.exports = __webpack_public_path__ + "img/report_5.2824ac6c.png";